import { safeStorage } from '@/lib/storage'

/** Stable per-browser id sent as `X-Device-Id` (LP-942). Survives reloads and sign-out; clearing site data gives a new one. */
export const DEVICE_ID_KEY = 'leazepro.deviceId'

let cached: string | null = null

function newId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return crypto.randomUUID()
  // Older browsers without randomUUID: a v4-shaped id from Math.random is enough for counting devices.
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16)
  })
}

/** The stored id, or a new one. When storage is blocked the id lives for this tab only. */
export function deviceId(): string {
  if (cached) return cached
  const stored = safeStorage.getItem(DEVICE_ID_KEY)
  if (typeof stored === 'string' && stored.length > 0 && stored.length <= 64) {
    cached = stored
    return stored
  }
  cached = newId()
  safeStorage.setItem(DEVICE_ID_KEY, cached)
  return cached
}

/** Tests only: forget the in-memory id so the next call reads storage again. */
export function resetDeviceIdForTests(): void {
  cached = null
}
